import { setGlobalSanitizeConfig } from "./config.js";
export function updateSanitizeConfig(newConfig) {
  if (!newConfig || typeof newConfig !== "object") {
    console.warn("updateSanitizeConfig: Provided config is invalid");
    return;
  }
  setGlobalSanitizeConfig(newConfig);
}
